import React, { useState } from 'react';
import UserManagementTab from './UserManagementTab';
import AdManagementTab from './AdManagementTab';
import AnalyticsTab from './AnalyticsTab';

const AdminDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'users' | 'ads' | 'analytics'>('users');

  return (
    <div className="h-full flex flex-col p-4 lg:p-6 max-w-7xl mx-auto overflow-hidden">
      {/* Tab Navigation */}
      <div className="mb-6 border-b border-slate-700">
        <div className="flex space-x-6">
          <button
            onClick={() => setActiveTab('users')}
            className={`py-3 px-1 font-medium text-sm border-b-2 ${
              activeTab === 'users'
                ? 'border-emerald-500 text-emerald-500'
                : 'border-transparent text-slate-400 hover:text-slate-300'
            }`}
          >
            User Management
          </button>
          <button
            onClick={() => setActiveTab('ads')}
            className={`py-3 px-1 font-medium text-sm border-b-2 ${
              activeTab === 'ads'
                ? 'border-emerald-500 text-emerald-500'
                : 'border-transparent text-slate-400 hover:text-slate-300'
            }`}
          >
            Ad Management
          </button>
          <button
            onClick={() => setActiveTab('analytics')}
            className={`py-3 px-1 font-medium text-sm border-b-2 ${
              activeTab === 'analytics'
                ? 'border-emerald-500 text-emerald-500'
                : 'border-transparent text-slate-400 hover:text-slate-300'
            }`}
          >
            Analytics
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'users' ? (
          <UserManagementTab />
        ) : activeTab === 'ads' ? (
          <AdManagementTab />
        ) : (
          <AnalyticsTab />
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
